/**
 * 1.3.48: 安全存储封装
 * - 优先使用 localStorage
 * - localStorage 不可用时（如隐私模式/受限环境）降级到 sessionStorage
 * - 两者都不可用则返回 null/忽略写入
 */

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function getStorageSafely(kind: 'local' | 'session'): StorageLike | null {
  try {
    const storage = kind === 'local' ? window.localStorage : window.sessionStorage;
    // 触发一次读写来验证可用性（有些环境访问会抛错）
    const testKey = '__storage_test__';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return storage;
  } catch {
    return null;
  }
}

function getPreferredStorage(): StorageLike | null {
  return getStorageSafely('local') ?? getStorageSafely('session');
}

export function safeStorageGet(key: string): string | null {
  const storage = getPreferredStorage();
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

export function safeStorageSet(key: string, value: string): void {
  const storage = getPreferredStorage();
  if (!storage) return;
  try {
    storage.setItem(key, value);
  } catch {
    // ignore
  }
}

export function safeStorageRemove(key: string): void {
  const storage = getPreferredStorage();
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch {
    // ignore
  }
}

